import { hFetch } from '@/lib/hfetch';

export type CalendarConnection = {
  id: number;
  calendar_connected: boolean;
};

export type CalendarConnectionDetail = {
  is_google_authenticated: boolean;
  is_microsoft_authenticated: boolean;
};

export const getCalendarConnections = async () => {
  return await hFetch<CalendarConnection[]>({ url: '/api/calendar_connections' });
};

export const getCalendarConnection = async (id: number) => {
  return await hFetch<CalendarConnectionDetail>({ url: `/api/calendar_connections/${id}` });
};
